module.exports = __webpack_public_path__ + "img/zuijia_03.15adba4a.png";